import { getReqHeaders, baseURL, $getRequest } from '@/util/request'

export default {
  name: 'UploadFile',
  data() {
    return {
      loading: false,
      visible: false,
      extra: {
        // name:''
      },
      headers: {

      },
      file: {
        name: null,
        id: null
      },
      defaultFileList: [],
      baseURL
    }
  },
  props: {
    format: {
      default: function() {
        return []
      }
    },
    data: {
      type: Object,
      default: function() {
        return {}
      }
    },
    value: {

    },
    title: {
      type: String,
      default: ''
    },
    displayFile: {
      type: Boolean,
      default: false
    },
    action: {
      type: String
    },
    maxSize: {
      type: Number,
      default: 2048
    },
    limit: {
      type: Number,
      default: 5
    },
    replyType:{
      type:String,
      default:'modal' //notice / mdal
    },
    errorTitle:{
      type:String,
      default:'上传失败' //notice / mdal
    },
    enableReply:{
      type:Boolean,
      default:true
    }
  },

  watch: {
    value(nv, ov) {
      if (nv && nv != ov) {
        this.defaultFileList = [{ id: nv, name: '下载' }]
      }
    },
    // extraField(nv){
    //   if(nv){
    //     for(let i in nv){
    //       this.extra[i] = nv[i]
    //     }
    //   }
    // }
  },

  created() {
    this.headers = getReqHeaders('upload')
  },

  methods: {
    handleRemove(file) {
      this.handleUpdate(file)
    },
    handleSuccess(res, file, fileList) {
      this.loading = false
      if(this.enableReply){
        if (res.code == 0) {
          this.file = res.data //{id: res.data.id , name:res.data.fileName}
          this.handleUpdate(res.data)
          this.$Notice.success({title:'上传成功' , desc:res.msg || '操作成功'})
        } else {
          this.$Notice.error({title:'上传失败', desc : res.msg || '操作失败'})
        }
      }
      console.log('upload>>>>>>>>>>>>')
      this.$emit('complete' , res)
    },
    handleError(res) {
      this.emit('error', res.message || res.msg)
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '错误的文件类型',
        desc: '文件 ' + file.name + ' 文件类型不匹配'
      })
      this.loading = false

    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小错误',
        desc: `文件  ${file.name} 必须在 ${this.maxSize}KB 以内.`
      })
      this.loading = false

    },
    handleBeforeUpload(file) {
      this.loading = true
    },

    handleUpdate(data) {
      this.$emit('success', data)
      this.$emit('input', data.id)
      this.dispatch('FormItem', 'on-form-change', [].concat(data.id))
      this.$emit('change', data)

    },

    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params));
      }
    },

    renderContent(){
      const { $scopedSlots , loading , title } = this
      const loadingEl = loading ? <Spin v-if="loading" class="spin-icon-load" style="display:inline-block;"><Icon type="ios-loading" size="18"></Icon></Spin> : null
      if( title ){
        return <a>
          { loadingEl }
          { title }
        </a>
      }else{
        return $scopedSlots.default ? $scopedSlots.default() : <Button type="primary" icon="ios-cloud-upload-outline">上传</Button>
      }
    },
    renderTip(){
      const { $scopedSlots } = this
      const vnode = [<p>大小限制 {Math.round(this.maxSize / 1024)} MB 以内</p>]
      if( $scopedSlots.tip ){
        vnode.push( $scopedSlots.tip() )
      }
      return vnode
    }
  },

  render(){
    const { $scopedSlots , renderContent } = this
    const detailEl = this.displayFile && this.file.id ? <a style="margin-left:25px;vertical-align: middle;">
        <Icon type="ios-link" style="vertical-align: middle;" />
        <span>{this.file.fileName}</span>
      </a> : null
    const contentEl = this.renderContent()

    const scopedSlots = {
      content:() => this.renderTip()
    }
    const props = {
      onSuccess:this.handleSuccess,
      onError:this.handleError,
      onFormatError:this.handleFormatError,
      onExceededSize:this.handleMaxSize
    }
    return (
      <Poptip trigger="hover" scopedSlots={scopedSlots}>
        <Upload {...{ props: props }} style="display:inline-block;" show-upload-list={false} data={this.data} default-file-list={this.defaultFileList} format={this.format} max-size={this.maxSize} headers={this.headers} before-upload={this.handleBeforeUpload} action={this.baseURL + this.action}>
            {contentEl}
        </Upload>
        {detailEl}
      </Poptip>
    )
  }
}